import { useState } from "react";
import { createClient } from "@supabase/supabase-js";

// Central Supabase project — same URL & anon key as Homepage.js
const supabase = createClient(
  "https://jzwpixujezkbkqjrxrhm.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp6d3BpeHVqZXprYmtxanJ4cmhtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI2NDExODMsImV4cCI6MjA5ODIxNzE4M30.X9tDrY5ehAIfZo98FpdzKP_r0GW9zK4HrZaZaagSS14",
);

// ─── Password gate ────────────────────────────────────────────────────────────
// Split into char-codes so the password isn't a single searchable string in the
// minified bundle. Still reversible by a determined inspector — combine with the
// obscure URL for two layers of friction.
// To change: replace the numbers with: [...'yourpassword'].map(c => c.charCodeAt(0))
const _PW = [
  114, 101, 118, 101, 114, 101, 110, 100, 105, 110, 115, 97, 110, 105, 116, 121,
];
const ADMIN_PW = String.fromCharCode(..._PW);

// ─── Lock-screen styles ───────────────────────────────────────────────────────
const ls = {
  overlay: {
    minHeight: "100vh",
    background:
      "linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  box: {
    background: "rgba(255,255,255,0.07)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 20,
    padding: "40px 32px",
    width: "100%",
    maxWidth: 360,
    boxShadow: "0 32px 80px rgba(0,0,0,0.4)",
    textAlign: "center",
  },
  lockIcon: { fontSize: 36, marginBottom: 12 },
  heading: { fontSize: 20, fontWeight: 700, color: "#fff", margin: "0 0 6px" },
  sub: { fontSize: 13, color: "rgba(255,255,255,0.4)", margin: "0 0 28px" },
  pwInput: {
    width: "100%",
    padding: "11px 14px",
    borderRadius: 10,
    border: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.06)",
    color: "#fff",
    fontSize: 15,
    boxSizing: "border-box",
    outline: "none",
    marginBottom: 12,
    letterSpacing: "0.1em",
    textAlign: "center",
  },
  pwBtn: {
    width: "100%",
    padding: "12px",
    borderRadius: 10,
    border: "none",
    background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
    color: "#fff",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    boxShadow: "0 4px 20px rgba(99,102,241,0.35)",
  },
  pwError: { marginTop: 12, fontSize: 13, color: "#fca5a5" },
};

const APP_OPTIONS = [
  {
    value: "all",
    label: "All 4 Apps",
    description: "JAMB, WAEC, NECO & Post-UTME",
    emoji: "🎓",
  },
  {
    value: "jamb",
    label: "JAMB CBT",
    description: "JAMB / UTME practice",
    emoji: "🧠",
  },
  {
    value: "waec",
    label: "WAEC CBT",
    description: "WAEC Objective & Theory",
    emoji: "📚",
  },
  {
    value: "neco",
    label: "NECO CBT",
    description: "NECO past questions",
    emoji: "📖",
  },
  {
    value: "post_utme",
    label: "Post-UTME",
    description: "University screening",
    emoji: "🏛️",
  },
];

const VALID_APPS = ["jamb", "waec", "neco", "post_utme"];

// ─── Styles ──────────────────────────────────────────────────────────────────

const s = {
  page: {
    minHeight: "100vh",
    background:
      "linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "48px 16px",
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  card: {
    background: "rgba(255,255,255,0.07)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 20,
    padding: "36px 32px",
    width: "100%",
    maxWidth: 520,
    boxShadow: "0 32px 80px rgba(0,0,0,0.4)",
  },
  badge: {
    display: "inline-block",
    background: "rgba(99,102,241,0.25)",
    border: "1px solid rgba(99,102,241,0.4)",
    color: "#a5b4fc",
    borderRadius: 100,
    padding: "4px 14px",
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "0.06em",
    marginBottom: 14,
    textTransform: "uppercase",
  },
  title: {
    fontSize: 26,
    fontWeight: 700,
    color: "#fff",
    margin: "0 0 6px",
  },
  subtitle: {
    fontSize: 14,
    color: "rgba(255,255,255,0.5)",
    margin: "0 0 32px",
  },
  label: {
    display: "block",
    fontSize: 13,
    fontWeight: 600,
    color: "rgba(255,255,255,0.75)",
    marginBottom: 8,
    letterSpacing: "0.04em",
  },
  input: {
    width: "100%",
    padding: "11px 14px",
    borderRadius: 10,
    border: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.06)",
    color: "#fff",
    fontSize: 14,
    boxSizing: "border-box",
    outline: "none",
    transition: "border-color 0.2s",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10,
    marginBottom: 24,
  },
  appOption: (selected) => ({
    padding: "12px 14px",
    borderRadius: 12,
    border: selected
      ? "1.5px solid #818cf8"
      : "1px solid rgba(255,255,255,0.1)",
    background: selected ? "rgba(99,102,241,0.2)" : "rgba(255,255,255,0.04)",
    cursor: "pointer",
    transition: "all 0.18s",
    display: "flex",
    alignItems: "center",
    gap: 10,
    color: selected ? "#e0e7ff" : "rgba(255,255,255,0.55)",
    userSelect: "none",
  }),
  appOptionEmoji: {
    fontSize: 20,
    lineHeight: 1,
  },
  appOptionText: {
    flex: 1,
  },
  appOptionLabel: (selected) => ({
    fontSize: 13,
    fontWeight: 600,
    color: selected ? "#e0e7ff" : "rgba(255,255,255,0.7)",
    display: "block",
  }),
  appOptionDesc: {
    fontSize: 11,
    color: "rgba(255,255,255,0.35)",
    display: "block",
    marginTop: 2,
  },
  dot: (selected) => ({
    width: 16,
    height: 16,
    borderRadius: "50%",
    border: selected ? "none" : "1.5px solid rgba(255,255,255,0.2)",
    background: selected ? "#818cf8" : "transparent",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  divider: {
    height: 1,
    background: "rgba(255,255,255,0.08)",
    margin: "24px 0",
  },
  refRow: {
    display: "flex",
    gap: 10,
    alignItems: "stretch",
    marginBottom: 24,
  },
  refInput: {
    flex: 1,
    padding: "11px 14px",
    borderRadius: 10,
    border: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.06)",
    color: "#fff",
    fontSize: 14,
    outline: "none",
  },
  refBtn: {
    padding: "0 14px",
    borderRadius: 10,
    border: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.06)",
    color: "rgba(255,255,255,0.5)",
    fontSize: 12,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  submitBtn: (loading) => ({
    width: "100%",
    padding: "14px",
    borderRadius: 12,
    border: "none",
    background: loading
      ? "rgba(99,102,241,0.35)"
      : "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
    color: loading ? "rgba(255,255,255,0.4)" : "#fff",
    fontSize: 15,
    fontWeight: 600,
    cursor: loading ? "not-allowed" : "pointer",
    letterSpacing: "0.02em",
    transition: "all 0.2s",
    boxShadow: loading ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
  }),
  successBox: {
    padding: "14px 16px",
    background: "rgba(52,211,153,0.12)",
    border: "1px solid rgba(52,211,153,0.3)",
    borderRadius: 10,
    color: "#6ee7b7",
    fontSize: 14,
    marginBottom: 20,
    lineHeight: 1.6,
  },
  errorBox: {
    padding: "14px 16px",
    background: "rgba(239,68,68,0.12)",
    border: "1px solid rgba(239,68,68,0.3)",
    borderRadius: 10,
    color: "#fca5a5",
    fontSize: 14,
    marginBottom: 20,
    lineHeight: 1.6,
  },
  historyHeader: {
    fontSize: 13,
    fontWeight: 600,
    color: "rgba(255,255,255,0.4)",
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    marginBottom: 10,
  },
  historyItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 12px",
    background: "rgba(255,255,255,0.04)",
    borderRadius: 8,
    marginBottom: 6,
    gap: 10,
  },
  historyEmail: {
    fontSize: 13,
    color: "rgba(255,255,255,0.7)",
    wordBreak: "break-all",
    flex: 1,
  },
  historyBadge: (plan) => ({
    fontSize: 11,
    fontWeight: 600,
    padding: "3px 8px",
    borderRadius: 100,
    background:
      plan === "all" ? "rgba(99,102,241,0.3)" : "rgba(52,211,153,0.2)",
    color: plan === "all" ? "#a5b4fc" : "#6ee7b7",
    whiteSpace: "nowrap",
    flexShrink: 0,
  }),
  historyTime: {
    fontSize: 11,
    color: "rgba(255,255,255,0.25)",
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function generateRef() {
  const ts = Date.now().toString(36).toUpperCase();
  const rand = Math.random().toString(36).slice(2, 7).toUpperCase();
  return `BANK-${ts}-${rand}`;
}

function fmtTime(ts) {
  return new Intl.DateTimeFormat("en-NG", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    day: "2-digit",
    month: "short",
  }).format(new Date(ts));
}

// ─── Component ────────────────────────────────────────────────────────────────

export default function AdminManualPay() {
  // ── All state must be declared before any conditional return (Rules of Hooks)
  const [unlocked, setUnlocked] = useState(false);
  const [pwInput, setPwInput] = useState("");
  const [pwError, setPwError] = useState(false);

  const [email, setEmail] = useState("");
  const [plan, setPlan] = useState("all");
  const [ref, setRef] = useState(generateRef());
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [history, setHistory] = useState([]);

  // ── Lock screen ──────────────────────────────────────────────────────────
  const handleUnlock = () => {
    if (pwInput === ADMIN_PW) {
      setUnlocked(true);
    } else {
      setPwError(true);
      setPwInput("");
      setTimeout(() => setPwError(false), 2000);
    }
  };

  if (!unlocked) {
    return (
      <div style={ls.overlay}>
        <div style={ls.box}>
          <div style={ls.lockIcon}>🔐</div>
          <h2 style={ls.heading}>Admin Access</h2>
          <p style={ls.sub}>Enter the admin password to continue.</p>
          <input
            type="password"
            value={pwInput}
            onChange={(e) => setPwInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleUnlock()}
            placeholder="••••••••"
            style={{
              ...ls.pwInput,
              border: pwError
                ? "1px solid rgba(239,68,68,0.6)"
                : "1px solid rgba(255,255,255,0.15)",
            }}
            autoFocus
          />
          <button style={ls.pwBtn} onClick={handleUnlock}>
            Unlock
          </button>
          {pwError && <p style={ls.pwError}>❌ Incorrect password</p>}
        </div>
      </div>
    );
  }

  // ── Submit ────────────────────────────────────────────────────────────────
  const handleActivate = async () => {
    const cleanEmail = email.toLowerCase().trim();

    if (!cleanEmail) {
      setError("Please enter the customer's email address.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleanEmail)) {
      setError("That doesn't look like a valid email address.");
      return;
    }

    setLoading(true);
    setResult(null);
    setError(null);

    const apps =
      plan === "all"
        ? [...VALID_APPS]
        : [plan].filter((p) => VALID_APPS.includes(p));

    try {
      // 1. Call the same RPC the Paystack webhook uses
      const { error: rpcErr } = await supabase.rpc("add_paid_apps", {
        user_email: cleanEmail,
        new_apps: apps,
      });
      if (rpcErr) throw new Error(`add_paid_apps: ${rpcErr.message}`);

      // 2. Record the bank-transfer reference + method (same columns as IAP/Paystack)
      if (ref.trim()) {
        await supabase
          .from("payments")
          .update({
            payment_ref: ref.trim(),
            payment_method: "bank_transfer",
          })
          .eq("email", cleanEmail);
        // Note: if there's no payments row yet for this email the update is a
        // no-op — that's fine, the row gets created later when the user logs in.
      }

      const entry = {
        email: cleanEmail,
        plan,
        ref: ref.trim(),
        ts: Date.now(),
      };
      setResult(entry);
      setHistory((h) => [entry, ...h].slice(0, 20));

      // Reset for next entry
      setEmail("");
      setRef(generateRef());
    } catch (err) {
      console.error(err);
      setError(err.message || "Something went wrong. Check the console.");
    } finally {
      setLoading(false);
    }
  };

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <div style={s.page}>
      <div style={s.card}>
        {/* Header */}
        <div style={s.badge}>⚡ Admin · Manual Payments</div>
        <h1 style={s.title}>Activate Bank Transfer</h1>
        <p style={s.subtitle}>
          Grant paid access to a user who paid via direct bank transfer. Mirrors
          the Paystack webhook — calls the same{" "}
          <code style={{ fontSize: 12, opacity: 0.7 }}>add_paid_apps</code> RPC.
        </p>

        {/* Alerts */}
        {result && (
          <div style={s.successBox}>
            ✅ <strong>{result.email}</strong> has been activated for{" "}
            <strong>
              {result.plan === "all"
                ? "all 4 apps (JAMB, WAEC, NECO & Post-UTME)"
                : APP_OPTIONS.find((a) => a.value === result.plan)?.label}
            </strong>
            .
            {result.ref && (
              <>
                {" "}
                Reference recorded:{" "}
                <code style={{ opacity: 0.8 }}>{result.ref}</code>
              </>
            )}
          </div>
        )}
        {error && <div style={s.errorBox}>❌ {error}</div>}

        {/* Email */}
        <div style={{ marginBottom: 20 }}>
          <label style={s.label}>Customer Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError(null);
            }}
            onKeyDown={(e) => e.key === "Enter" && handleActivate()}
            placeholder="student@example.com"
            style={s.input}
            autoComplete="off"
            spellCheck={false}
          />
        </div>

        {/* Plan picker */}
        <div style={{ marginBottom: 8 }}>
          <label style={s.label}>Plan / Apps to Activate</label>
        </div>
        <div style={s.grid}>
          {APP_OPTIONS.map((opt) => {
            const sel = plan === opt.value;
            return (
              <div
                key={opt.value}
                style={{
                  ...s.appOption(sel),
                  // span "All 4 Apps" across both columns
                  ...(opt.value === "all" ? { gridColumn: "1 / -1" } : {}),
                }}
                onClick={() => setPlan(opt.value)}
                role="radio"
                aria-checked={sel}
                tabIndex={0}
                onKeyDown={(e) => e.key === " " && setPlan(opt.value)}
              >
                <span style={s.appOptionEmoji}>{opt.emoji}</span>
                <span style={s.appOptionText}>
                  <span style={s.appOptionLabel(sel)}>{opt.label}</span>
                  <span style={s.appOptionDesc}>{opt.description}</span>
                </span>
                <span style={s.dot(sel)}>
                  {sel && (
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
                      <circle cx="4" cy="4" r="4" fill="#fff" />
                    </svg>
                  )}
                </span>
              </div>
            );
          })}
        </div>

        {/* Reference */}
        <div style={{ marginBottom: 24 }}>
          <label style={s.label}>Payment Reference (optional)</label>
          <div style={s.refRow}>
            <input
              type="text"
              value={ref}
              onChange={(e) => setRef(e.target.value)}
              placeholder="e.g. BANK-ABC123"
              style={{ ...s.refInput, flex: 1, boxSizing: "border-box" }}
              spellCheck={false}
            />
            <button
              style={s.refBtn}
              onClick={() => setRef(generateRef())}
              title="Generate a new reference"
            >
              🔄 New
            </button>
          </div>
          <p
            style={{ fontSize: 12, color: "rgba(255,255,255,0.3)", margin: 0 }}
          >
            Stored in <code>payments.payment_ref</code> with{" "}
            <code>payment_method = 'bank_transfer'</code>.
          </p>
        </div>

        {/* Submit */}
        <button
          style={s.submitBtn(loading)}
          disabled={loading}
          onClick={handleActivate}
        >
          {loading ? "Activating…" : "✅ Activate Access"}
        </button>

        {/* Session history */}
        {history.length > 0 && (
          <>
            <div style={s.divider} />
            <p style={s.historyHeader}>Session Log</p>
            {history.map((h, i) => (
              <div key={i} style={s.historyItem}>
                <span style={s.historyEmail}>{h.email}</span>
                <span style={s.historyBadge(h.plan)}>
                  {h.plan === "all"
                    ? "All apps"
                    : APP_OPTIONS.find((a) => a.value === h.plan)?.label}
                </span>
                <span style={s.historyTime}>{fmtTime(h.ts)}</span>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
